<template>
	<div style="height: 100%;">
		<div class="bg-w pd10" style="height: 100%;">
			<div class="flex " style="height: 100%;">
				<div class="cash-register-left">
					<div class="pd10">
						<a-input-search placeholder="请输入条形码" enter-button @search="onSearch" />
					</div>
					<div class="cash-register-left-info">
						<div class="flex alcenter space">
							<div v-if="JSON.stringify(cashierMember)=='{}'" class="cl-price flex alcenter" style="line-height: 1;" @click="chooseMemberAct()">
								<i class="iconfont iconorder_operation_coach ft12  mr5" />
								选择会员
							</div>
							<div v-else class="cl-theme flex alcenter" style="line-height: 1;" @click="chooseMemberAct()">
								{{cashierMember.nick_name}} <div class="ml5 cl-red" @click="chooseMemberAct()">重新选择</div>
							</div>
							<div class="ft16 ftw500 cl-main">购物车</div>
						</div>
					</div>
					
					<div class="cash-register-left-content">
						<template v-for="(item,index) in cashierCart">
							<cart-goods v-if="item.type=='goods'" :datas="item" :index="index"></cart-goods>
							<cart-service v-if="item.type=='service'" :datas="item" :index="index"></cart-service>
						</template>
					</div>

					<div class="cash-register-left-bottom">
						<div class="flex alcenter space">
							<div>
								<div class="flex alcenter">
									<div class="cl-black">合计</div>
									<div class="cl-theme">{{getTotalNum}}件</div>
									<div class="cl-black">商品</div>
								</div>
								<div class="mt10">
									<div class="cl-green ft16">优惠￥{{getYouhuiPrice}}</div>
								</div>
							</div>

							<div>
								<div >
									<div class="cl-black flex end">合计￥{{getTotalPrice}}</div>
									
								</div>
								<div class="mt10 ">
									<div class="cl-price ft16 flex end">应收￥{{getNeedPay}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="cash-register-right">
					<div class=" text-center " style="padding: 15px 0px;">常用操作</div>
					<div class="cash-register-right-action" style="border-top:1px solid #EFF0F0 ;" @click="editNumAct()">数量
						<a-icon type="form" class="ft14" />
					</div>
					<div class="cash-register-right-action" @click="delAct()">删除
						<a-icon type="delete" class="ft14" />
					</div>
					<div class="cash-register-right-action" @click="guaAct()">挂单
						<a-icon type="database" class="ft14" />
					</div>
					<div class="cash-register-right-button">
						<div class="cash-register-right-button-blue" @click="clearCart()">清空菜单</div>
						<div class="cash-register-right-button-red" @click="payAct()">结算</div>
					</div>
				</div>
			</div>
			
			<div v-if="editNumVisible">
				<edit-num :visible="editNumVisible" @cancel="cancelEditNum" @ok="okEditNum"></edit-num>
			</div>
			<div v-if="chooseMemberVisible">
				<choose-member :visible="chooseMemberVisible" @cancel="cancelChooseMember" @ok="okChooseMember"></choose-member>
			</div>
		</div>
	</div>
</template>

<script>
	import cartGoods from './cashRegister/goods.vue';
	import cartService from './cashRegister/service.vue';
	import editNum from './cashRegister/modal/editNum.vue';
	import chooseMember from './cashRegister/modal/chooseMember.vue'
	export default {
		components:{
			cartGoods,
			cartService,
			editNum,
			chooseMember,
		},
		data() {
			return {
				editNumVisible:false,
				chooseMemberVisible:false,
			}
		},
		computed:{
			getTotalPrice(){
				let total_price=0;
				if(this.cashierCart.length>0){
					let price=0;
					for( var i in this.cashierCart){
						if(this.cashierCart[i].type=='goods'){
							if(this.cashierCart[i].sku_id>0){
								price=this.cashierCart[i].sku_original_price;
							}else{
								price=this.cashierCart[i].original_price;
							}
						}else{
							price=this.cashierCart[i].market_price
						}
						total_price += (parseFloat(price)*100 * this.cashierCart[i].num)/100
					}
				}
				
				return total_price.toFixed(2);
				
			},
			getTotalNum(){
				let num=0;
				if(this.cashierCart.length>0){
					for( var i in this.cashierCart){
						num+=this.cashierCart[i].num;
					}
				}
				
				return num;
			},
			getNeedPay(){
				let need_pay=0;
				if(this.cashierCart.length>0){
					let price=0;
					for( var i in this.cashierCart){
						if(this.cashierCart[i].type=='goods'){
							if(this.cashierCart[i].sku_id>0){
								price=this.cashierCart[i].sku_original_price;
							}else{
								price=this.cashierCart[i].original_price;
							}
							// if(JSON.stringify(this.cashierMember)!='{}'){
							// 	if(this.cashierMember.level_id>0){
							// 		if(this.cashierCart[i].sku_id>0){
							// 			price=this.cashierCart[i].sku_vip_price;
							// 		}else{
							// 			price=this.cashierCart[i].vip_price;
							// 		}
							// 	}
							// }
							
							let vip_level=0;
							if(JSON.stringify(this.cashierMember)!='{}'){
								if(this.cashierMember.level!=null){
									vip_level=this.cashierMember.level.vip_level;
									if(this.cashierCart[i].sku_id>0){
										if(this.cashierCart[i].only_one_vip==0){
											if(vip_level==1){
												price=this.cashierCart[i].sku_vip1_price;
											}else if(vip_level==2){
												price=this.cashierCart[i].sku_vip2_price;
											}else if(vip_level==3){
												price=this.cashierCart[i].sku_vip3_price;
											}else if(vip_level==4){
												price=this.cashierCart[i].sku_vip4_price;
											}else if(vip_level==5){
												price=this.cashierCart[i].sku_vip5_price;
											}else{
												price=this.cashierCart[i].sku_vip1_price;
											}
										}else{
											price=this.cashierCart[i].sku_vip_price;
										}
										
									}else{
										
										if(this.cashierCart[i].only_one_vip==0){
											if(vip_level==1){
												price=this.cashierCart[i].vip1_price;
											}else if(vip_level==2){
												price=this.cashierCart[i].vip2_price;
											}else if(vip_level==3){
												price=this.cashierCart[i].vip3_price;
											}else if(vip_level==4){
												price=this.cashierCart[i].vip4_price;
											}else if(vip_level==5){
												price=this.cashierCart[i].vip5_price;
											}else{
												price=this.cashierCart[i].vip1_price;
											}
										}else{
											price=this.cashierCart[i].vip_price;
										}
										
									}
								}
							}
						}else{
							price=this.cashierCart[i].market_price;
						}
						need_pay += (parseFloat(price)*100 * this.cashierCart[i].num)/100
					}
				}
				
				return need_pay.toFixed(2);
			},
			
			getYouhuiPrice(){
				return ((parseFloat(this.getTotalPrice)*100 - parseFloat(this.getNeedPay)*100)/100).toFixed(2);
			}
		},
		methods: {
			onSearch(value) {
				
			},
			
			chooseMemberAct(){
				this.chooseMemberVisible=true;
			},
			cancelChooseMember(){
				this.chooseMemberVisible=false;
			},
			okChooseMember(){
				this.chooseMemberVisible=false;
			},
			
			editNumAct(){
				if(this.cashierCartIndex==-1){
					this.$message.error('请选择商品');
					return false;
				}
				
				if(!this.cashierCart[this.cashierCartIndex]){
					this.$message.error('请选择商品');
					return false;
				}
				
				this.editNumVisible=true;
			},
			cancelEditNum(){
				this.editNumVisible=false;
			},
			okEditNum(){
				this.editNumVisible=false;
			},
			
			delAct(){
				if(this.cashierCartIndex==-1){
					this.$message.error('请选择商品');
					return false;
				}
				
				if(!this.cashierCart[this.cashierCartIndex]){
					this.$message.error('请选择商品');
					return false;
				}
				let cart=JSON.parse(JSON.stringify(this.cashierCart));
				cart.splice(this.cashierCartIndex,1);
				this.$store.commit('setCashierCart',cart);
				this.$store.commit('setCashierCartIndex',-1);
			},
			
			guaAct(){
				if(this.cashierCart.length<=0){
					this.$message.error('还没有商品，无法挂单');
					return false;
				}
				
				let gua = JSON.parse(JSON.stringify(this.gua));
				gua.unshift({
					member:this.cashierMember,
					cart:this.cashierCart,
					total_price:this.getTotalPrice,
					total_num:this.getTotalNum,
					need_pay:this.getNeedPay,
					add_time_format:this.getTime(),
				})
				this.$store.commit('setGua',gua);
				this.$store.commit('setCashierCart',[]);
				this.$store.commit('setCashierCartIndex',-1);
				this.$store.commit('setMember',{});
			},
			
			clearCart(){
				this.$store.commit('setCashierCart',[]);
				this.$store.commit('setCashierCartIndex',-1);
			},
			
			payAct(){
				if(this.cashierCart.length<=0){
					this.$message.error('还没有商品，无法结算');
					return false;
				}
				this.$router.push('/cash/pay');
			},
			getTime(){
				const date = new Date();
				const year = date.getFullYear();
				const month = date.getMonth() + 1;
				const day = date.getDate();
				const hour = date.getHours();
				const minute = date.getMinutes();
				const second = date.getSeconds();
				this.month = check(month);
				this.day = check(day);
				this.hour = check(hour);
				this.minute = check(minute);
				this.second = check(second);
							
				function check(i) {
					const num = (i < 10) ? ("0" + i) : i;
					return num;
				}
							
				return year + "-" + this.month + "-" + this.day + " " + this.hour + ":" + this.minute + ":" + this.second;
			}
		}
	}
</script>

<style>
	.cash-register-left {
		width: 75%;
		height: 100%;
		position: relative;
	}

	.cash-register-left-info {
		padding: 15px 10px;
		background: #F5F5F5;

	}

	.cash-register-left-bottom {
		position: absolute;
		bottom: 0px;
		left: 0;
		width: 100%;
		padding: 10px 10px;
		background: #F5F5F5;
	}

	.cash-register-right {
		width: 25%;
		background: #F5F7FA;
		border: 1px solid #F2F3F5;
		height: 100%;
		position: relative;
	}

	.cash-register-right-action {
		border-bottom: 1px solid #EFF0F0;
		font-size: 16px;
		font-weight: 500;
		color: #000000;
		padding: 15px 0;
		text-align: center;
		cursor: pointer;

	}

	.cash-register-right-button {
		position: absolute;
		bottom: 0px;
		left: 0;
		width: 100%;
	}

	.cash-register-right-button-blue {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background: #4772FF;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
		color: #ffffff;
	}

	.cash-register-right-button-red {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background: red;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
		color: #ffffff;
	}
	
	.cash-register-left-content{
		height: calc(100% - 200px);
		overflow: auto;
	}
</style>
